import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { AuthForm } from "@/components/auth/AuthForm";
import { useLanguage } from "@/contexts/LanguageContext";

interface PartnerLoginModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const PartnerLoginModal = ({ open, onOpenChange }: PartnerLoginModalProps) => {
  const { isRTL } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md p-0 border-0 bg-transparent shadow-none data-[state=open]:slide-in-from-bottom-8">
        <DialogTitle className="sr-only">Partner Sign in</DialogTitle>
        <DialogDescription className="sr-only">Sign in to JouRex Partner Portal</DialogDescription>
        <div className="rounded-2xl overflow-hidden bg-card shadow-elevated ring-1 ring-violet-500/30">
          <div className="[&>div]:!p-0 [&>div]:!min-h-0 [&_.absolute.inset-0]:!hidden">
            <AuthForm isRTL={isRTL} forcedRole="ib" variant="partner" />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
